import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { OptionsType } from "../interfaces/ApplicationInterfaces";
import APPSETTINGS from '../settings.json';

export function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

export const generateOptionType = (label: string, value: string): OptionsType => {
    return { label: label, value: value, isDisabled: false, hidden: false };
}

export const generateReactSelectDropdown = (values: Record<string, string>): Array<OptionsType> => {
    return Object.keys(values).map((key: string) => generateOptionType(values[key], key));
}

export const customReactSelectStyle = {
    control: (provided: any) => ({
        ...provided,
        maxHeight: 36,
        marginBottom: '0.75rem'
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        maxHeight: 36
    }),
    placeholder: (provided: any) => ({
        ...provided,
        maxHeight: 20,
        marginBlock: 5,
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        display: 'inline-block'
    }),
    singleValue: (provided: any) => ({
        ...provided,
        maxHeight: 20,
        marginBlock: 5,
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        display: 'inline-block'
    })
}

export const isNullUndefEmptyObject = (ob: any) => {
    if ((ob === undefined) || (ob === null)) {
        return true;
    }
    for (const prop in ob) {
        if (ob.hasOwnProperty(prop)) {
            return false;
        }
    }
    return true;
}

export const isNullUndefEmpty = (entry: string | undefined | null) => {
    if(entry === null || entry === undefined || entry.trim() === '')
        return true;
    return false;
}

interface PageViewAccess {
  group?: string[],
  scim?: string
}

interface IEnvSettings {
    "Environment Name": string,
    simplifiedUI: boolean,
    cosmosapi: string,
    externalapi: string,
    iefapi: string,
    msalAuthority: string,
    msalClientId: string,
    msalOtherPortalClientId: string,
    msalScope: string,
    tenantId: string,
    orgs: {
        default: {
            sisu: string
        }
    },
    authorityDomain: Array<string>,
    pallette: {
        primary: {main: string},
        secondary: {main: string}
    },
    logoURL: string,
    defaultCountry: string,
    defaultSearchUsersToAllCountries?: boolean,
    showOrgsForSingleAdmin?: boolean,
    doNotShowAdminApp?: boolean,
    needReasonForAppRejection?: boolean,
    privilegedLogTypes?: string[],
    showContactUsPage?: boolean,
    disableEmailChange?: boolean,
    showGroupsPage?: boolean,
    showGroupsReviewRequests?: boolean,
    disableNewUserCreation?: boolean,
    disableAppProvisioning?: boolean,
    showScimApplication?: boolean,
    pageViewAccess?: PageViewAccess,
    allowStubUsersForAccountLinking?: boolean
}

export const AppEnvSetting: IEnvSettings = APPSETTINGS//import.meta.env.PROD ? APPSETTINGS.production : APPSETTINGS.development;